import { render, staticRenderFns } from "./pa-information.vue?vue&type=template&id=39120c1e&"
import script from "./pa-information.vue?vue&type=script&lang=js&"
export * from "./pa-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports